<template>
	<div class="solution-page">
		<header class="navbar" fixed>
			<div class="back-btn" @click="handleBack">
				<img :src="backPng" class="back-img" />
			</div>
			<h1 class="navbar-title">查看解决方案</h1>
		</header>

		<!-- 加载中状态 -->
		<div v-if="loading" class="loading-container">
			<div class="loading-spinner"></div>
			<div class="loading-text">加载中...</div>
		</div>

		<!-- 错误状态 -->
		<div v-else-if="error" class="error-container">
			<div class="error-icon">❌</div>
			<div class="error-message">{{ errorMessage }}</div>
			<button class="retry-button" @click="fetchDetail">重新加载</button>
		</div>

		<!-- 正常内容 -->
		<main v-else class="content">
			<div class="answer-container">
				<Markdown :text="answer" />
			</div>
			<div class="tips">
				<div class="tip-line"></div>
				<div class="tip-text">&nbsp;以上方案是否解决了您的问题？&nbsp;</div>
				<div class="tip-line"></div>
			</div>

			<Vote :tags="tags" :sign="sign" :name="name" :id="id" />
		</main>
	</div>
</template>

<script>
import backPng from '@/assets/image/left_arrow.png'
import Vote from './Vote.vue'
import Markdown from '@/components/markdown/index.vue'
import api from '@/api/api'

export default {
	components: {
		Vote,
		Markdown,
	},
	
	data() {
		return {
			backPng,
			answer: '',
			loading: true, // 加载状态
			error: false, // 错误状态
			errorMessage: '加载失败，请稍后重试', // 错误信息
			tags: [],
			sign: '',
			name: '',
			id: '',
			appid: '',
			enterid: '',
		}
	},
	methods: {
		handleBack() {
			this.$router.go(-1)
		},
		
		fetchDetail() {
			this.loading = true
			this.error = false

			const params = {
				appid: this.appid,
				enterid: this.enterid,
				knowId: this.id,
				sign: this.sign,
			}
			api
				.getHotDetail(params)
				.then(res => {
					console.log(res)
					if (res && res.answer) {
						this.answer = res.answer
						this.tags = res.unhelpfulList || []
						this.loading = false
					} else {
						this.error = true
						this.loading = false
						this.errorMessage = '获取数据失败，请稍后重试'
					}
				})
				.catch(err => {
					console.error('Error fetching detail:', err)
					this.error = true
					this.loading = false
					this.errorMessage = '网络请求失败，请检查网络连接'
				})
		},
	},
	
	mounted() {
		this.id= this.$route.query.id
		this.name= this.$route.query.name
		this.sign= this.$route.query.sign
		this.appid= this.$route.query.appid
		this.enterid= this.$route.query.enterid
		this.fetchDetail()
	},
}
</script>
<style lang="less">
html,
body {
	height: 100%;
}
.app {
	background-color: #fff;
}
</style>
<style scoped lang="less">
.navbar {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	.px2rem(height, 48);
	background-color: #ffffff;
	display: flex;
	align-items: center;
	.px2rem(padding-left, 15);
	.px2rem(padding-right, 15);
	.px2rem(padding-top, 48);
	z-index: 1000;

	&::after{
		content: '';
		position: absolute;
		left: 0;
		bottom: 0;
		width: 100%;
		height: 1px;
		background-color: #e5e5e5;
		transform: scaleY(0.5);
		transform-origin: center bottom;
	}
}

.back-btn {
	cursor: pointer;
	.px2rem(width, 20);
	position: absolute;
}

.back-img {
	// position: absolute;
	cursor: pointer;
	.px2rem(width, 20);
	top: 50%;
	transform: rotate(180deg);
}

.navbar-title {
	flex: 1;
	text-align: center;
	.px2rem(font-size, 18);
	font-weight: 500;
	margin: 0;
}

.content {
	.px2rem(padding-left, 15);
	.px2rem(padding-right, 15);
	.px2rem(padding-top, 104);
	overflow-y: auto;
}

.tips {
	display: flex;
	align-items: center;

	.tip-line {
		position: relative;
		height: 0;
		flex: 1;

		&::after {
			content: '';
			position: absolute;
			left: 0;
			bottom: 0;
			width: 100%;
			height: 1px;
			background-color: #e5e5e5;
			transform: scaleY(0.5);
			transform-origin: center bottom;
		}
	}

	.tip-text {
		color: rgba(155, 161, 175, 1);
	}
}

.answer-container {
	.px2rem(margin-bottom, 20);
	.px2rem(font-size, 16);
	// text-align: justify;
	word-break: break-all;
	color: #1A1D25;
}

// 加载状态样式
.loading-container {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	.px2rem(padding-top, 120);
	.px2rem(padding-bottom, 100);
}

.loading-spinner {
	width: 40px;
	height: 40px;
	border: 3px solid #f3f3f3;
	border-top: 3px solid #409eff;
	border-radius: 50%;
	animation: spin 1s linear infinite;
	.px2rem(margin-bottom, 16);
}

@keyframes spin {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}

.loading-text {
	color: rgba(26, 29, 37, 0.85);
	.px2rem(font-size, 14);
}

// 错误状态样式
.error-container {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	.px2rem(padding-top, 120);
	.px2rem(padding-bottom, 100);
	.px2rem(padding-left, 20);
	.px2rem(padding-right, 20);
	text-align: center;
}

.error-icon {
	.px2rem(font-size, 48);
	.px2rem(margin-bottom, 16);
}

.error-message {
	color: rgba(26, 29, 37, 0.85);
	.px2rem(font-size, 16);
	.px2rem(margin-bottom, 24);
	.px2rem(line-height, 24);
}

.retry-button {
	padding: 8px 16px;
	background-color: #409eff;
	color: white;
	border: none;
	border-radius: 4px;
	.px2rem(font-size, 14);
	cursor: pointer;
	transition: background-color 0.3s ease;

	&:hover {
		background-color: #66b1ff;
	}
}
</style>

<style lang="stylus">
.markdown-wrap p{
  margin: 0;
}
.markdown video, .markdown img{
  max-width: 100%;
}
.markdown ul, .markdown ol{
  li::marker{
    color: #2290FD;
  }
}
.follow-up-question{
  color: #2290FD;
  cursor: pointer;
}

.markdown table {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
}
.markdown table th,
.markdown table td {
  border: 1px solid #d9d9d9;
  padding: 6px;
  text-align: left;
}

</style>
